import React, { useRef } from 'react';
import { Box } from '@mui/material';
import styled from '@emotion/styled';
import ClusterSelector from '../../../common/ClusterSelector';
import { ActiveStatus } from '../../../common/filters';
import QualifyingConsultantCard from './QualifyingConsultantCard';
import ResultsCount from '../../../common/ResultsCount';
import Grid from '../../../common/Grid/Grid';

const TabWrapper = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: white;
  overflow: hidden;
`;

const FixedHeader = styled.div`
  flex-shrink: 0;
  padding: 24px 24px 16px 24px;
`;

const GridContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 0 16px 16px 16px;
`;

const QualifyingConsultantsTab = ({
  consultants,
  isLoading,
  isLoadingMore,
  pageInfo,
  loadMoreData,
  clusterFilter,
  onClusterFilterChange,
  activeStatuses,
  onActiveStatusToggle
}) => {
  const gridRef = useRef(null);

  const renderConsultantCard = ({ item }) => {
    return <QualifyingConsultantCard consultant={item} />;
  };

  return (
    <TabWrapper>
      {/* Fixed header with filters and results count */}
      <FixedHeader>
        {/* Filters row */}
        <Box sx={{
          display: 'flex',
          gap: 3,
          mb: 2,
          alignItems: 'center',
          flexWrap: 'wrap'
        }}>
          <Box sx={{ minWidth: 250 }}>
            <ClusterSelector
              value={clusterFilter}
              onChange={onClusterFilterChange}
              label="Cluster"
              allowSelectAll={true}
              allOptionLabel="All Clusters"
              allOptionValue=""
              showStructureType // ADR-119
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  height: '40px',
                  backgroundColor: 'white',
                  '& fieldset': {
                    borderColor: '#E2E8F0',
                  },
                  '&:hover fieldset': {
                    borderColor: '#CBD5E1',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#2563EB',
                  }
                }
              }}
            />
          </Box>

          <ActiveStatus
            selectedStatuses={activeStatuses}
            onStatusToggle={onActiveStatusToggle}
          />
        </Box>

        {/* Results count */}
        {!isLoading && pageInfo?.totalCount !== undefined && (
          <ResultsCount
            count={pageInfo.totalCount}
            singular="individual"
            plural="individuals"
          />
        )}
      </FixedHeader>

      {/* Grid area */}
      <GridContainer>
        <Grid
          items={consultants}
          isLoading={isLoading}
          isLoadingMore={isLoadingMore}
          pageInfo={pageInfo}
          renderItem={renderConsultantCard}
          loadMoreData={loadMoreData}
          gridRef={gridRef}
          rowHeight={120}
          emptyStateTitle="No Qualifying Individuals Found"
          emptyStateDescription="No individuals qualify for this role based on the current position and grade mappings, or try adjusting your filters."
          endOfListMessage="You've reached the end of the list"
          useContainerDimensions
          containerHeightOffset={150}
        />
      </GridContainer>
    </TabWrapper>
  );
};

export default QualifyingConsultantsTab;
